<template>
  <CRow>
    <div v-if="spinner">
      <vue-element-loading :active="true" :is-full-screen="true" />
    </div>
    <CCol col="12" md="12" v-else>
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            <b> DFS Betting List </b>

            <CButton
              block
              color="success"
              style="float: right; width: 120px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            >
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="tableData"
            :fields="fields"
            pagination
            clickable-rows
            hover
          >
            <template #image="{ item }">
              <td>
                <img :src="item.image" style="width: 50px; height: 50px" />
              </td>
            </template>
            <template #status="{ item }">
              <td v-if="item.endtime.seconds < todaydate.seconds">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-warning ml-1"
                >
                  completed
                </a>
              </td>
              <td v-else>
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-primary ml-1"
                >
                  Live
                </a>
              </td>
            </template>
            <!-- <template #status="{ item }">
              <td>
                <span v-if="item.status == true">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-success ml-1"
                  >
                    Active
                  </a></span
                >
                <span v-else>
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-danger ml-1"
                  >
                    InActive
                  </a>
                </span>
              </td>
            </template> -->
            <template #Action="{ item, index }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                  @click="editToken(item, index)"
                >
                  Edit </CButton
                ><br /><br />
              </td>
            </template>
            <template #completed="{ item, index }">
              <br />
              <CButton
                style="margin-top: -15px; width: -webkit-fill-available"
                v-if="item.completed"
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="modelopen(item, index)"
              >
                Set Answer
              </CButton>
              <br />
              <br />
              <CButton
                style="margin-top: -15px; width: -webkit-fill-available"
                v-if="item.completed"
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="Cancelled(item, index)"
              >
                Cancelled &nbsp;&nbsp;
              </CButton>
              <br />
              <br />
              <CButton
                style="margin-top: -15px; width: -webkit-fill-available"
                v-if="item.completed"
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="breakmatch(item, index)"
              >
                Break &nbsp;&nbsp;
              </CButton>
              <br />
            </template>
          </CDataTable>
          <CModal title="Add Prediction Answer" :show.sync="myModal">
            <CCol sm="12">
              <label>Match Title</label>
              <CInput
                style="color: black; font-weight: bold"
                placeholder="Enter MatchID"
                v-model="Match"
                disabled
              />
            </CCol>
            <!-- <CCol sm="12">
              <label>Prediction Question</label>
              <CInput
                style="color: black; font-weight: bold"
                placeholder="Enter MatchID"
                v-model="Quizquestion"
                disabled
              />
            </CCol> -->
            <CCard style="padding: 10px">
              <CRow>
                <!-- :value="this.option1" -->
                <CCol sm="4" v-for="answer in options" :key="answer">
                  <input
                    type="radio"
                    v-model="quizAnswer"
                    name="profileImg"
                    :value="answer"
                  />
                  <span style="color: black; font-weight: bold">
                    {{ answer }}</span
                  >
                </CCol>
              </CRow>
            </CCard>
            <CCard style="padding: 10px" v-if="answeravailable">
              <h5>
                Selected answer is <u>{{ quizAnswer }}</u>
              </h5>
            </CCard>
            <template #footer>
              <!-- <CButton @click="darkModal = false" color="danger">cancel</CButton> -->
              <CButton
                color="success"
                :disabled="isActive"
                @click="sendAnswer()"
                >Save</CButton
              >
            </template>
          </CModal>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.5.17/vue.js"></script>
<script>
import VueElementLoading from "vue-element-loading";
import CTableWrapper from "../tables/Table";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import { secondaryDatabase } from "./secondary.js";
import moment from "moment";
import axios from "axios";
export default {
  components: { CTableWrapper, VueElementLoading },
  data() {
    return {
      answeravailable: false,
      options: [],
      profileImg: "",
      myModal: false,
      quizAnswer: "",
      spinner: false,
      isActive: false,
      fields: [
        {
          label: "Match Id",
          key: "id",
          sortable: true,
        },
        {
          label: "Match",
          key: "Match",
          sortable: true,
        },
        {
          label: "Date",
          key: "Date",
          sortable: true,
        },
        {
          label: "StartDate",
          key: "StartDate",
          sortable: true,
        },
        {
          label: "EndDate",
          key: "EndDate",
          sortable: true,
        },
        {
          label: "Token Name",
          key: "tokenName",
          sortable: true,
        },
        {
          label: "Status",
          key: "status",
          sortable: true,
        },

        // {
        //   key: "Action",
        //   sortable: true,
        // },
        {
          label: "completed",
          key: "completed",
          sortable: true,
        },
      ],
      speciesCode: null,
      speciesName: "",
      documentId: "",
      tableData: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      image1: false,
      todaydate: null,
      Quiztitle: "",
      Quizquestion: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      Match: "",
      matchId: "",
    };
  },
  watch: {
    quizAnswer() {
      if (this.quizAnswer != "") {
        this.answeravailable = true;
      }
    },
  },
  methods: {
    check(event) {},
    modelopen(item, index) {
      this.myModal = true;
      secondaryDatabase
        .collection("bettingtest")
        .doc(item.id)
        .get()
        .then((snapshot) => {
          //   (this.Quiztitle = snapshot.data().team1),
          //     (this.Quizquestion = snapshot.data().team2),
          this.Match = snapshot.data().team1 + " vs " + snapshot.data().team2;
          this.options = snapshot.data().options;
          this.quizId = snapshot.id;
          this.matchId = snapshot.data().matchId;
          //   this.points = snapshot.data().point;
        });
    },
    sendAnswer() {
      if (this.quizAnswer == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Quiz Answer",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        this.myModal = false;
        this.isActive = true;
        this.spinner = true;
        let docId = this.quizId;
        let answer = this.quizAnswer;
        let matchId = this.matchId;

        let data = {
          docId,
          answer,
          matchId,
        };

        axios
          .post(
            "https://us-central1-token-geomine.cloudfunctions.net/dfs/addbettingpoint",
            { ...data }
          )
          .then((res) => {
            this.spinner = false;
            this.isActive = false;
            if (res.data.status) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: res.data.Message,
                showConfirmButton: false,
                timer: 4000,
              });
              window.setInterval(() => {
                window.location.reload();
              }, 4000);
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title: res.data.Message,
                showConfirmButton: false,
                timer: 2000,
              });
              window.setInterval(() => {
                window.location.reload();
              }, 3000);
            }
          });
      }
    },

    reload() {
      window.location.reload();
    },
    wizard() {
      this.$router.push({ name: "betting" });
    },
    editToken(item, index) {
      this.$router.push({
        name: "editPrediction",
        params: { id: item.id, data: "DFS" },
      });
    },

    getquiz() {
      this.tableData = [];
      // let dbs = secondaryDB.secondaryDatabase;
      secondaryDatabase
        .collection("bettingtest")
        .where("dfs", "==", true)
        .where("answer", "==", null)
        .orderBy("quizdate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            //   "doc.data().endtime.seconds",
            //   doc.data().endtime.seconds
            // );
            this.tableData.push({
              id: doc.id,
              quizTitle: doc.data().team1,
              question: doc.data().team2,
              options: doc.data().options,
              answer: doc.data().answer,
              status: doc.data().status,
              image: doc.data().image,
              quiztype: doc.data().quiztype,
              starttime: doc.data().starttime,
              endtime: doc.data().endtime,
              scramble: doc.data().scramble,
              matchId: doc.data().matchId,
              Match: doc.data().team1 + " vs " + doc.data().team2,
              dfs: doc.data().dfs,
              completed: doc.data().endtime.seconds < this.todaydate.seconds,
              Date: moment(doc.data().quizdate.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              StartDate: moment(doc.data().starttime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              EndDate: moment(doc.data().endtime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              tokenName: doc.data().tokenName,
            });
          });

          this.loading = false;
        });
    },
    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    loader(onload) {
      if (onload) {
        Swal.fire({
          title: "Please Wait !",
          closeOnClickOutside: false,
          allowOutsideClick: false, // add html attribute if you want or remove
          onOpen: () => {
            Swal.showLoading();
          },
        });
      }
    },

    Cancelled(item) {
      this.documentId = item.id;
      this.MatchId = item.matchId;

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.spinner = true;
            let docId = this.documentId;
            let matchId = this.MatchId;
            let data = {
              docId,
              matchId,
            };
            axios
              .post(
                "https://us-central1-token-geomine.cloudfunctions.net/dfs/cancelBettingNew",
                { ...data }
              )
              // axios
              //   .post(
              //     "http://localhost:5000/token-geomine/us-central1/dfs/cancelBettingNew",
              //     { ...data }
              //   )
              .then((res) => {
                this.spinner = false;
                console.log(res.data);
                if (res.data.status) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: res.data.Message,
                    showConfirmButton: false,
                    timer: 4000,
                  });
                  window.setInterval(() => {
                    window.location.reload();
                  }, 3000);
                } else {
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: res.data.Message,
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  window.setInterval(() => {
                    window.location.reload();
                  }, 3000);
                }
              });

            // this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)"
            );
          }
        });
    },
    breakmatch(item) {
      this.documentId = item.id;
      this.MatchId = item.matchId;

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.spinner = true;
            let docId = this.documentId;
            let matchId = this.MatchId;
            let data = {
              docId,
              matchId,
            };
            axios
              .post(
                "https://us-central1-token-geomine.cloudfunctions.net/dfs/breakMactchbyID",
                { ...data }
              )
              // axios
              //   .post(
              //     "http://localhost:5000/rage-fan-beta/us-central1/dfs/breakMactchbyID",
              //     { ...data }
              //   )
              .then((res) => {
                this.spinner = false;
                if (res.data.status) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: res.data.Message,
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  window.setInterval(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: res.data.Message,
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  window.setInterval(() => {
                    window.location.reload();
                  }, 3000);
                }
              });

            // this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)"
            );
          }
        });
    },
    deletecompanyDetails(item) {
      db.collection("companyDetails2")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.getquiz();
    this.todaydate = firebase.firestore.Timestamp.fromDate(new Date());
  },
};
</script>
<style>
.swal2-cancel {
  margin: 10px !important;
}
</style>
<style>
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
.badge-warning {
  color: white;
  background-color: #f9b115;
}
.modal-dialog {
  max-width: 550px;
  margin: 1.75rem auto;
}
</style>
